'use client';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { hover } from '@/styles/globalStyleVars';

const PreloaderWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #3C3C3B;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
    opacity: 1;
    visibility: visible;
    transition: height 1s ease, opacity 1s ease, visibility 1s ease;

    &.fade-out {
        opacity: 0;
        visibility: hidden;
    }
`;

const SpinningLogo = styled.svg`
    width: 300px;
    height: 300px;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: reveal 3s ease forwards;

    @keyframes reveal {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }
`;

const Preloader = () => {
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        const fakeDelayForDemo = 500; // Adjust this delay as needed
        const timer = setTimeout(() => {
            setFadeOut(true);
        }, fakeDelayForDemo);

        return () => clearTimeout(timer);
    }, []);

    return (
        <PreloaderWrapper className={fadeOut ? 'fade-out' : ''}>
            <SpinningLogo
            id="logo" xmlns="http://www.w3.org/2000/svg" width="168.274" height="40" viewBox="0 0 168.274 40">
                <defs>
                    <clipPath id="clip-path">
                        <rect id="Rectangle_6590" data-name="Rectangle 6590" width="168.274" height="40" fill="none"/>
                    </clipPath>
                </defs>
                <g id="Group_21260" data-name="Group 21260">
                    <g id="Group_21259" data-name="Group 21259" clip-path="url(#clip-path)">
                        <path id="Path_10545" data-name="Path 10545" d="M4.922,34.256C-6.3,25.2,1.873-4.408,27.435.556c5.849,2.352,4.74,12.02-3.574,10.81C4.615,3.328-.785,28.862,4.919,34.252h0l0,0,.011.01-.006,0c4.989,6.053,30.822,2.333,24.061-17.412C28.325,8.462,38.037,7.989,40,13.982,43.28,39.835,13.214,46.063,4.922,34.256" transform="translate(0 0.001)" fill="#978c21" fill-rule="evenodd"/>
                        <path id="Path_10546" data-name="Path 10546" d="M584.886,143.58h2.935v16.874h-2.935v-7.019h-9.9V150.5h9.9Zm17.65.494a2.172,2.172,0,0,0-1.335-.543,2.3,2.3,0,0,0-1.333.568,3.956,3.956,0,0,0-.961,1.087l-9.162,15.241h3.779l7.6-12.5,2.938,4.87H599.6l-1.778,2.917h8l2.837,4.716,3.777.028L603.5,145.186a3.964,3.964,0,0,0-.965-1.111m-28.884-.494h-2.941v16.874h2.941Zm-7.261,7.78a6.011,6.011,0,0,0-4.071-1.409h-7.952a2.337,2.337,0,0,1-1.434-.442,1.488,1.488,0,0,1-.589-1.262,1.522,1.522,0,0,1,.589-1.256,2.245,2.245,0,0,1,1.434-.473h12.713V143.58H554.369a5.624,5.624,0,0,0-3.678,1.213,4.548,4.548,0,0,0,0,6.89,5.607,5.607,0,0,0,3.678,1.213h7.952a3.987,3.987,0,0,1,2.076.519,1.931,1.931,0,0,1,1.034,1.753,2.058,2.058,0,0,1-1.013,1.8,3.907,3.907,0,0,1-2.1.543H549.456v2.941H562.32a6.135,6.135,0,0,0,4.071-1.36,4.816,4.816,0,0,0,1.7-3.853,4.889,4.889,0,0,0-1.7-3.881m61.352,3.927L616.93,144.446a2.459,2.459,0,0,0-1.679-.866,1.077,1.077,0,0,0-.915.433,1.687,1.687,0,0,0-.319,1.026v15.416h2.913v-11.71l10.813,10.869a2.789,2.789,0,0,0,1.827,1.016c.74,0,1.111-.547,1.111-1.633V143.58h-2.938Zm40.388,5.167-8.937-15.268a3.781,3.781,0,0,0-.964-1.111,2.146,2.146,0,0,0-1.33-.543,2.28,2.28,0,0,0-1.332.568,3.971,3.971,0,0,0-.965,1.087l-9.161,15.241h3.779l7.6-12.5,2.941,4.87H655.3l-1.778,2.917h8l2.837,4.716Zm-24.908,0V146.518h6.638V143.58H633.644v2.938h6.665v13.936ZM549.456,170.5h3.6v-.716H550.23v-2.717h2.743v-.716H550.23V164.3h2.826v-.716h-3.6Zm28.26-1.073,1.005,1.02h-.951l-.561-.6a3.117,3.117,0,0,1-.956.484,3.53,3.53,0,0,1-1.063.173,3.4,3.4,0,0,1-2.468-1.007,3.432,3.432,0,0,1,0-4.9,3.474,3.474,0,0,1,4.993,4.83m.223-2.387a2.683,2.683,0,0,0-.8-1.956,2.742,2.742,0,0,0-3.9,0,2.779,2.779,0,0,0,0,3.908,2.63,2.63,0,0,0,1.943.816,2.416,2.416,0,0,0,1.495-.5l-1.619-1.623h.978L577.2,168.9a2.586,2.586,0,0,0,.738-1.854m23.629.591v.108c0,.228,0,.4-.009.528a2.023,2.023,0,0,1-.092.46,1.309,1.309,0,0,1-.24.464,1.661,1.661,0,0,1-.612.443,1.877,1.877,0,0,1-.75.162,1.9,1.9,0,0,1-.787-.176,1.512,1.512,0,0,1-.612-.473,1.372,1.372,0,0,1-.221-.5,2.436,2.436,0,0,1-.079-.464q0-.163,0-.55v-4.051h-.773v4.258a4.029,4.029,0,0,0,.134,1.128,1.888,1.888,0,0,0,.548.839,2.5,2.5,0,0,0,1.8.695,2.466,2.466,0,0,0,1.869-.776,1.884,1.884,0,0,0,.493-.812,4.208,4.208,0,0,0,.114-1.074v-4.258h-.773Zm19.712,2.869h.774v-6.92h-.774Zm19.124-6.2h1.676v6.2h.773v-6.2h1.694v-.716H640.4Zm25.066,2.368-1.768-3.083h-.893l2.274,3.947V170.5h.773v-2.973l2.275-3.947h-.894Z" transform="translate(-499.858 -130.657)" fill="#fff"/>
                    </g>
                </g>

        </SpinningLogo>
        </PreloaderWrapper>
    );
};

export default Preloader;
